/**
 * 帮助与反馈入口组件
 *
 */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { openOrDownloadUrl } from '@/utils/open-or-download-url';
import { className, isInYoda, sendClick, sendShow } from '@/utils/helpers';
import { getTargetUrl } from '@/utils/url';
import { getCookie } from '@/utils/cookies';
import FeedbackAvatar from '@/assets/home/feedback-avatar.png';

import './index.scss';

interface IProps {
  isFollowBarShow: boolean;
}

const HelpFeedbackEntrance = ({ isFollowBarShow }: IProps) => {
  const history = useHistory();

  const handleFeedback = () => {
    sendClick('SUSPENDED_CUSTOMER_SERVICE_CARD');
    const url = getTargetUrl(
      `${window.location.origin}/feedback/help-feedback?layoutType=4&enableWK=1&hyId=healthy-channel`
    );
    if (isInYoda) {
      openOrDownloadUrl(url);
    } else {
      history.push('/feedback/help-feedback');
    }
  };

  useEffect(() => {
    if (isFollowBarShow) {
      sendShow('SUSPENDED_CUSTOMER_SERVICE_CARD');
    }
  }, [isFollowBarShow]);

  return (
    <div
      className={className(
        'feedback-entrance-avatar',
        isFollowBarShow ? 'feedback-is-follow-bar-show' : ''
      )}
    >
      <img
        role="presentation"
        src={FeedbackAvatar}
        onClick={handleFeedback}
        alt=""
      />
    </div>
  );
};

export default HelpFeedbackEntrance;
